import React from "react";
import "./disclaimer.scss";

const disclaimerBullets = [
  "The generation and delivery of AI-based videos and content are dependent on third-party systems, which may be subject to downtime, delays, interruptions, or technical malfunctions beyond our control.",
  "We shall not be held liable or responsible for any direct, indirect, incidental, consequential, or special damages, losses, or claims arising out of or in connection with the use of third-party APIs or the content generated through them.",
  "The platform may generate or process content that could be considered sensitive, explicit, or not safe for work (NSFW). We do not guarantee content moderation accuracy, and users are solely responsible for reviewing, filtering, and ensuring that such content complies with applicable laws, community standards, and platform policies before use, distribution, or publication.",
  "We do not assume any responsibility for intellectual property violations, including but not limited to copyright, trademark, likeness rights, or unauthorized use of content that may arise from AI-generated outputs. Users bear full responsibility for verifying usage rights and legal compliance.",
  "We are not responsible for the data handling, storage, or processing practices of third-party service providers, which are governed by their respective privacy policies and terms of service.",
  "Users agree not to use the platform for generating, distributing, or promoting unlawful, harmful, abusive, or prohibited content, and any such misuse is solely the responsibility of the user.",
];

const Disclaimer = () => {
  return (
    <div className="disclaimer-page">
      <div className="disclaimer-shell">
        <header className="disclaimer-hero">
          <span>Legal Notice</span>
          <h1>Disclaimer</h1>
          <p>
            Please review how third-party AI systems are used across Zullu AI
            and what responsibilities apply when generating media.
          </p>
        </header>

        <section className="disclaimer-panel">
          <p>
            Our platform utilizes third-party application programming interfaces
            (APIs), tools, and services to generate, process, and deliver
            AI-based video and media content. These third-party providers
            function independently, and we do not own, operate, or control their
            underlying systems, algorithms, data processing mechanisms, or
            outputs.
          </p>

          <p>
            While we strive to integrate reliable and reputable technologies, we
            make no representations or warranties regarding the accuracy,
            quality, legality, reliability, or appropriateness of any content
            generated through such third-party services. AI-generated outputs may
            contain errors, unintended elements, or content that may be
            inaccurate, misleading, offensive, or unsuitable for certain
            audiences.
          </p>

          <div className="acknowledgement-block">
            <h2>By accessing or using our platform, you expressly acknowledge and agree that:</h2>
            <ul>
              {disclaimerBullets.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <p>
            Furthermore, we reserve the right to update, modify, suspend, or
            discontinue any part of the platform or its third-party integrations
            at any time without prior notice. Continued use of our services
            constitutes full acceptance of this disclaimer and any future
            updates.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Disclaimer;
